import module from './module.js'
// Components
import './components/component.js'
import './components/launcher/component.js'
// LNF
import './components/clientes/component.js'
import './components/clientes/item/component.js'
import './components/proveedores/component.js'
import './components/proveedores/item/component.js'
import './components/sucursales/component.js'
import './components/sucursales/lista/component.js'
import './components/sucursales/lista/item/component.js'
import './components/sucursales/editar/component.js'
import './components/sucursales/editar/inicializar/component.js'
import './components/sucursales/editar/cuentas/component.js'
import './components/sucursales/confirmar/component.js'

// Algodoneros
import './components/clientesag/component.js'
import './components/clientesag/item/component.js'
import './components/proveedoresag/component.js'
import './components/proveedoresag/item/component.js'
import './components/productosag/component.js'
import './components/productosag/item/component.js'
import './components/butacas/component.js'
import './components/butacas/item/component.js'
// Services
// LNF
import './services/CatalogosExternosClientes.js'
import './services/CatalogosExternosProveedores.js'
import './services/CatalogosExternosSucursales.js'
import './services/sucursal/CatalogosExternosSucursalCuentasContables.js'
import './services/CatalogosExternosCatalogosFamilias.js'
// Algodoneros
import './services/CatalogosExternosClientesAg.js'
import './services/CatalogosExternosProveedoresAg.js'
import './services/CatalogosExternosProductosAg.js'
import './services/CatalogosExternosButacas.js'
// Routes
import './routes/contabilidad-catalogosexternos.js'
// LNF
import './routes/contabilidad-catalogosexternos-clientes.js'
import './routes/contabilidad-catalogosexternos-proveedores.js'
import './routes/contabilidad-catalogosexternos-sucursales.js'
// Algodoneros
import './routes/contabilidad-catalogosexternos-clientesag.js'
import './routes/contabilidad-catalogosexternos-proveedoresag.js'
import './routes/contabilidad-catalogosexternos-productosag.js'
import './routes/contabilidad-catalogosexternos-butacas.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/index.js